'use client';

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';

type Props = { lang: Locale };

const EventManagementFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <FinalCTA
      accent="#22D3EE"
      ariaLabel={t('EventManagement/FinalCTA/aria_label')}
      copy={{
        headlineA: t('EventManagement/FinalCTA/title1'),
        headlineB: t('EventManagement/FinalCTA/title2'),
        subhead: t('EventManagement/FinalCTA/subtitle'),
        ctaPrimary: {
          label: t('EventManagement/FinalCTA/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('EventManagement/FinalCTA/cta_secondary'),
          href: `/${lang}/contact-us`,
        },
      }}
    />
  );
};

export default EventManagementFinalCTA;
